import React from 'react'
import styles from './TeamsEmpty.m.sass'
import Button from 'components/Button'
import { EmptyState, EmptyStateIllustrationImage } from 'components/EmptyState'
import { useBrandingSettings } from 'hooks/branding'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  onCreateTeamRequest: () => void
  showCreateActions: boolean
}

export default function TeamsEmpty({
  onCreateTeamRequest,
  showCreateActions,
}: Props) {
  const { corporateMode } = useBrandingSettings()
  return (
    <div className={styles.root}>
      <EmptyState
        hideIllustration={corporateMode}
        image={
          <EmptyStateIllustrationImage
            src={require('assets/images/img_no-teams.svg')}
          ></EmptyStateIllustrationImage>
        }
        title="Looking a little empty..."
        subtitle={
          <>
            This workspace has no teams{' '}
            {showCreateActions && (
              <>
                <br /> Lets go create one.
              </>
            )}
          </>
        }
      >
        {showCreateActions && (
          <Button onClick={() => onCreateTeamRequest()} type="primary">
            Create Team
          </Button>
        )}
      </EmptyState>
    </div>
  )
}
